import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, Inject, Optional, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ExpedienteSinClave } from '@models/expediente/expedienteSinClave.model';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ButtonActionComponent } from 'src/app/component/button-action/button-action.component';
import { ButtonExportFileComponent } from 'src/app/component/button-export-file/button-export-file.component';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';

@Component({
  standalone: true,
  imports: [AppRolesDirective, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, SinDatosParaMostrarComponent, ButtonNewComponent, SinDatosParaMostrarComponent, ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, CommonModule, FormsModule, MatSortModule, NgxSpinnerModule, FormsModule, ReactiveFormsModule, CommonModule, ButtonNewComponent, ButtonFilterTableComponent, ButtonExportFileComponent, ButtonActionComponent, SinDatosParaMostrarComponent, MatTooltipModule, MatPaginatorModule, MatRippleModule],
  selector: 'app-dialog-expedientes-enviados',
  templateUrl: './dialog-expedientes-enviados.component.html',
  styleUrls: ['./dialog-expedientes-enviados.component.css']
})
export class DialogExpedientesEnviadosComponent {


  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<ExpedienteSinClave>();
  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;
  data!: boolean;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  constructor(
    public dialogRef: MatDialogRef<DialogExpedientesEnviadosComponent>,
    private breakpointObserver: BreakpointObserver,
    @Optional() @Inject(MAT_DIALOG_DATA) public expedienteSinClave: ExpedienteSinClave[]
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ["caratula", "correoEnviado"] :
        ["caratula", "identificadorUnico", "juzgado", "correo", "correoEnviado", "fallaEnvioCorreo"];
    });
  }

  ngOnInit(): void {
    this.dataSource.data = this.expedienteSinClave
    this.data = this.dataSource.data.length >= 1 ? true : false
  }


  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }
}
